"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldButtonCoreInputs = void 0;
const button_alignment_1 = require("./button.alignment");
const button_color_1 = require("./button.color");
const button_elevation_1 = require("./button.elevation");
const button_shape_1 = require("./button.shape");
const button_size_1 = require("./button.size");
const button_variant_1 = require("./button.variant");
const icon_inputs_1 = require("../icon/icon.inputs");
class EmeraldButtonCoreInputs {
    constructor() {
        this.variant = button_variant_1.EmeraldButtonVariant.Primary;
        this.disabled = false;
        this.color = button_color_1.EmeraldButtonColor.Primary;
        this.shape = button_shape_1.EmeraldButtonShape.Rectangular;
        this.mini = false;
        this.light = false;
        this.stroked = false;
        this.elevation = button_elevation_1.EmeraldButtonElevation.None;
        this.ripple = true;
        this.size = button_size_1.EmeraldButtonSize.Medium;
        this.iconPosition = button_alignment_1.EmeraldButtonAlignment.Left;
        this.iconFillType = icon_inputs_1.EmeraldIconType.Filled;
        this.type = button_variant_1.EmeraldButtonVariant.Primary;
        this.danger = false;
        this.fullWidth = false;
    }
}
exports.EmeraldButtonCoreInputs = EmeraldButtonCoreInputs;
//# sourceMappingURL=button.inputs.js.map